import React, { Component } from 'react';
import  AuthService  from "../api/authentication.js";

import {
    BrowserRouter as Router,
    Route,
    Link,
    Redirect
  } from 'react-router-dom'

import "./login.css"
// https://uvune-events.herokuapp.com
const Auth = new AuthService();

class SignIn extends Component {
   constructor(props){
       super(props)
       this.state ={
        domain: 'https://exam-end.herokuapp.com', 
        localApi:'http://localhost:4000',  
            isLoggedIn:false,
            errormessage : "",
            erorrDiv : false,
            loading : false,
            submitIftrue : true,
            noerorrpage :  true,
            organizers404 : false
       }
       
   }

  
   componentDidMount(){
    this.props.noerorrpage(this.state.noerorrpage)
    // console.log("url===--->", this.state.domain)
    
   }

  
    signIn = (event)=>{
        event.preventDefault()
        // console.log("headchange", this.email.value, this.password.value )
        this.setState({
            loading : true
        })
        const login ={
            username : this.email.value,
            password :this.password.value,
            "strategy":"local"

        }
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' },
            body: JSON.stringify(login),
        };
        //console.log("requestOptions",requestOptions)
        fetch(this.state.domain+"/schools/login", requestOptions)
        .then(res => res.json())
        .then((res)=>{
            console.log("res", res)
            if(res.status === false){
                console.log("res", res)    
                this.setState({
                    errormessage:"The Username or Password you have entered is incorrect.  Please try again.",
                    erorrDiv : true,
                    loading : false
                })
                this.timeout()
            }else if(Auth.loggedIn){
                Auth.setToken(res.token) ;
                // console.log("dat check for login ");

                //Getuser
                const requestOptions = {
                    method: 'GET',
                    headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken() },
                    
                };

                return fetch(this.state.domain+"/school/"+Auth.getProfile().id, requestOptions )
                .then(res => res.json())
                .then(res => {
                    //  console.log("res getting user data", res);
                    if(res.status === true){
                        const user = res;
                        // console.log(" user login =======", user)
                        // console.log("res", res.code)    
                            this.setState({
                                // errormessage:"Invalid Email or Password ",
                                // erorrDiv : true,
                                loading : false,
                                organizers404:true,
                            })
                            this.props.setGlobalAuthState();
                            this.props.setGlobalUser(user);
                            // this.props.setGlobalorganizers(result);
                         
                            this.props.organizers404(this.state.organizers404)
                            this.props.history.replace('/dashboard');
                     
                  }               
                        
                        return res;
                 }).catch(err => err);
             }
          
           }).catch( (error) => {
            //  console.log("errro", error);
            //  console.log("error load", error )
         });

    }

    timeout() {
        setTimeout(function() {
            this.setState({
                erorrDiv : false
            })
        //   console.log(this.state.noticeshow);
        }.bind(this), 4000);
    }

    isEmpty=(val)=>{
        return (val === undefined || val === null || val.length <= 0) ? true : false;
    }
  

    // checkUsers = ()=>{
    //     if(!this.props.user.fullname == "" && !this.props.user.address == ""  &&  !this.props.user.about == ""
    //     && !this.props.user.account_no == "" 
    //      && !this.props.user.phone_one =="" && !this.props.user.phone_two == "" ){
    //          this.setState({
    //            submitIftrue : true,
    //          })
    //        return true
    //    }else{
    //        this.setState({
    //            submitIftrue : false
    //          })
    //        return  false
    //    }
    //   }

  render() {
    // console.log("this.state.isLoggedIn login", this.state);
    // console.log("this.props.isAuthenticated login", this.props.isAuthenticated);

    return (

         this.state.isLoggedIn || this.props.isAuthenticated ?
            
            <Redirect to={{    pathname: `${'/dashboard'}`  }}/>

        :
      
        !this.props.isAuthenticated ? (
            
                 <div className="login-fullbody">
                     <div className="login-img-body">
                        <img src="https://res.cloudinary.com/codepally/image/upload/v1616584548/Ridora/png/Ridora_Logo_white-08_ifvjth.png"/>
                       
                        </div>
                        
                        <div class="login-body-input">
                           <h4 class="login-body-input-h4">Login</h4>
                          <hr/>
                          <form onSubmit={this.signIn}>
                          <div class="login-body-input-sub">
                            <div class="field">
                                    <label class="form-label"><small>Username</small></label>
                                    <div class="control">
                                        <input type="text" class="input is-medium"
                                        onChange={this.handleChange} type="text"  
                                        ref={input=>this.email = input}  placeholder="Enter Username " required
                                        />
                                    </div>
                                   
                                    { this.state.erorrDiv  ?
                                        <div class="_9a1ab_k0UMi">
                                            {this.state.errormessage}
                                       </div>   
                                         :
                                        ""
                                    }   
                                    
                                   
                            </div>
                          
                            <div class="field" style={{marginTop:"25px"}}>
                                    <label class="form-label"><small>Password</small> 
                                    {/* <a class="_65514_3A2Fa"  href="https://uvune.com/recovery" target="_blank">Forgot Password?</a>   */}
                                    </label>
                                    <div class="control">
                                        <input type="text" class="input is-medium"
                                        type="password"  ref={input=>this.password = input} 
                                        placeholder="Enter Password"
                                        onChange={this.handleChange} required
                                        />
                                    </div>
                            </div>
                            
                            <div class="mt-20" style={{marginTop:"25px"}}>
                                { this.state.loading     ?  
                                    <div className="level-item">
                                        <a className="button is-loading is-large is-light">Loading</a>
                                    </div>   
                                        
                                    :  
                                     <button class="button is-success" style={{width:"100%"}}>Login</button>
                                    // <button class="button button-cta btn-align .is-success is-fullwidth btn-outlined is-bold rounded raised no-lh">Login</button>
                                }
            
                                 
                            </div>
                            
                          </div>
                          </form>
                          {/*
                                <div class="f17a7_1fMa1">
                                        <span style={{textAlign:"center"}}> Don't have an Account? </span>
                                        <a class="button is-danger is-outlined" style={{width:"100%",marginTop:"10px"}} href="/signup">
                                            <span>Create an Account</span>
                                            
                                        </a>
                                        <a class="a5075_16PDh" href="/account/signup">  </a>
                                    </div>
                         */}
                        </div>

                    </div>
                    
           
           
             
    ) : (

            <div className="hero is-bold is-fullheight">
                <div className="level-item">
                <a className="button is-loading is-large is-light">Loading</a>
                </div>
                <div className="level-item">
                  <p>Loaing.....</p>
                </div>
            </div>
    
    )
)



}





}

export default SignIn;


// WEBPACK FOOTER //
// ./src/component/login/login.js